import { IZoneTreeNode } from 'types/zoneTree.interface'

export const ZONE_TREE_DATA: IZoneTreeNode[] = [
  {
    id: 'zone-mine-a',
    name: 'Mine A',
    level: 'ZONE',
    status: 'operational',
    children: [
      {
        id: 'section-n',
        name: 'Section N',
        level: 'SECTION',
        status: 'operational',
        children: [
          {
            id: 'block-n-1',
            name: 'Block N-1',
            level: 'BLOCK',
            status: 'operational',
            children: [
              {
                id: 'pit-n-1-a',
                name: 'Pit N-1-A',
                level: 'PIT',
                status: 'operational',
              },
            ],
          },
          {
            id: 'block-n-2',
            name: 'Block N-2',
            level: 'BLOCK',
            status: 'operational',
            children: [
              {
                id: 'pit-n-2-a',
                name: 'Pit N-2-A',
                level: 'PIT',
                status: 'operational',
              },
            ],
          },
        ],
      },
      {
        id: 'section-s',
        name: 'Section S',
        level: 'SECTION',
        status: 'operational',
        children: [
          {
            id: 'block-s-1',
            name: 'Block S-1',
            level: 'BLOCK',
            status: 'operational',
            children: [
              {
                id: 'pit-s-1-a',
                name: 'Pit S-1-A',
                level: 'PIT',
                status: 'operational',
              },
            ],
          },
        ],
      },
    ],
  },
]
